import { __ } from 'i18n/index';
import { Request } from 'components/Request';

const initializedWorkspaces = new WeakSet();

export function initializeBugWorkspace(workspace, {
	reload = () => window.location.reload(),
	confirmDelete = () => window.confirm(__('Delete this report? This cannot be undone.')),
} = {}) {
	if (!workspace || initializedWorkspaces.has(workspace)) {
		return;
	}
	initializedWorkspaces.add(workspace);

	const description = workspace.querySelector('[data-report-description]');
	const descriptionInput = workspace.querySelector('[data-report-description-input]');
	const descriptionControls = workspace.querySelector('[data-report-description-controls]');
	const editButton = workspace.querySelector('[data-report-action="edit-description"]');
	const confirmedInput = workspace.querySelector('[data-report-confirmed]');
	const error = workspace.querySelector('[data-report-error]');
	const savedDescription = descriptionInput?.value;
	let confirmed = confirmedInput?.checked;
	let saving = false;

	const setEditing = editing => {
		if (!descriptionInput || !description || !descriptionControls) {
			return;
		}
		description.hidden = editing;
		descriptionInput.hidden = !editing;
		descriptionControls.hidden = !editing;
		if (editButton) {
			editButton.hidden = editing;
		}
		if (editing) {
			descriptionInput.focus();
		} else {
			descriptionInput.value = savedDescription;
			editButton?.focus();
		}
	};

	const save = async data => {
		if (saving) {
			return;
		}
		saving = true;
		if (error) {
			error.hidden = true;
		}
		const controls = Array.from(workspace.querySelectorAll('button, input, textarea, select'));
		const disabledStates = controls.map(control => control.disabled);
		controls.forEach(control => { control.disabled = true; });
		try {
			const response = await Request.post(siteUrl + '/bugs/update_bug', {
				bug_id: workspace.dataset.bugId,
				...data,
			});
			if (!response?.success || String(response.bug?.id) !== workspace.dataset.bugId) {
				throw new Error('Report update failed');
			}
			confirmed = confirmedInput?.checked;
			reload();
		} catch (failure) {
			if (confirmedInput) {
				confirmedInput.checked = confirmed;
			}
			if (error) {
				error.textContent = __('Could not save the report. Please try again.');
				error.hidden = false;
			}
		} finally {
			controls.forEach((control, index) => { control.disabled = disabledStates[index]; });
			saving = false;
		}
	};

	workspace.addEventListener('click', event => {
		const button = event.target.closest('[data-report-action]');
		if (!button || !workspace.contains(button)) {
			return;
		}
		event.preventDefault();
		if (saving || button.disabled) {
			return;
		}
		switch (button.dataset.reportAction) {
			case 'edit-description':
				setEditing(true);
				break;
			case 'cancel-description':
				setEditing(false);
				break;
			case 'save-description':
				if (descriptionInput) {
					save({ description: descriptionInput.value });
				}
				break;
			case 'close':
				save({ fixed: 1 });
				break;
			case 'reopen':
				save({ fixed: 0 });
				break;
		}
	});

	confirmedInput?.addEventListener('change', () => {
		if (!saving) {
			save({ confirmed: confirmedInput.checked ? 1 : 0 });
		}
	});

	workspace.querySelector('[data-report-delete]')?.addEventListener('submit', event => {
		if (saving || !confirmDelete()) {
			event.preventDefault();
		}
	});
}

export function initializeBugWorkspaces(root = document) {
	root.querySelectorAll('.bug-workspace[data-bug-id]').forEach(workspace => initializeBugWorkspace(workspace));
}
